import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

export const SetUpDomainBanner = (
    <FlashBanner hasBorder={true} type='warning'>
        <div className='full-width flex justify-sb'>
            <Body>Set up your domain first to upgrade the tracking snippet</Body>
            {/* @ts-expect-error */}
            <Link variant='primary' to='/setup/domains' as={RouterLink} newTab={true}>
                Set up domain
            </Link>
        </div>
    </FlashBanner>
);
